/** Hash set before the SW update reload; consumed once to glow the version button. */
export const WHATS_NEW_HASH = '#whatsnew';
export const SW_UPDATE_QUERY_PARAM = 'swUpdate';

export const isWhatsNewHash = (hash) => hash === WHATS_NEW_HASH;

export const setWhatsNewHash = () => {
    window.location.hash = WHATS_NEW_HASH.slice(1);
};

/**
 * Same-document `replace(#whatsnew)` does not reload: the modal closes and the
 * old JS stays. Strip `?swUpdate` via replace (search actually changes);
 * otherwise reload after setting the hash.
 */
export const whatsNewReloadPlan = (href) => {
    const url = new URL(href, 'http://localhost');
    const hadSwUpdate = url.searchParams.has(SW_UPDATE_QUERY_PARAM);
    url.searchParams.delete(SW_UPDATE_QUERY_PARAM);
    url.hash = WHATS_NEW_HASH.slice(1);
    const next = `${url.pathname}${url.search}${url.hash}`;
    return {
        method: hadSwUpdate ? 'replace' : 'reload',
        href: next,
    };
};

export const whatsNewReloadUrl = (href) => whatsNewReloadPlan(href).href;

export const reloadWithWhatsNewHint = () => {
    const plan = whatsNewReloadPlan(window.location.href);
    if (plan.method === 'replace') {
        window.location.replace(plan.href);
        return;
    }

    window.location.hash = WHATS_NEW_HASH.slice(1);
    window.location.reload();
};
